<template>
  <img
    :src="photo"
    :alt="name"
    :class="cssClass"
    @error="setPlaceholderPhoto"
  >
</template>
<script>
export default {
  name: "LegislatorImage",
  props: {
    cssClass: {
      type: String,
      default: "leg-results__results--entry-photo"
    },
    name: {
      type: String,
      default: null
    },
    photo: {
      required: true,
      type: String
    },
    placeholderPhotoUrl: {
      type: String,
      default: null
    }
  },
  methods: {
    setPlaceholderPhoto() {
      this.$el.setAttribute("src", this.placeholderPhotoUrl);
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
